function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZotero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m 16.0789,2.0004178 a 3.2974,3.1836 0 0 0 -1.727,0.4247 l -9.7023,5.4084 A 3.2974,3.1836 0 0 0 3.0009,10.590518 l 0,10.817 a 3.2974,3.1836 0 0 0 1.6487,2.757 l 9.7026,5.4085 a 3.2974,3.1836 0 0 0 3.2974,0 l 9.7026,-5.4085 a 3.2974,3.1836 0 0 0 1.649,-2.758 l 0,-10.817 a 3.2974,3.1836 0 0 0 -1.649,-2.7570002 l -9.702,-5.4084 a 3.2974,3.1836 0 0 0 -1.571,-0.4247 z",
    style: {
      fill: "#e4e4e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.0789,1.9995178 a 3.2974,3.1836 0 0 0 -1.726,0.4258 l -9.7036,5.4082 A 3.2974,3.1836 0 0 0 3.0009,10.591518 l 0,1 A 3.2974,3.1836 0 0 1 4.6493,8.8335178 l 9.7036,-5.4082 a 3.2974,3.1836 0 0 1 1.726,-0.4258 3.2974,3.1836 0 0 1 1.57,0.4258 l 9.7031,5.4082 a 3.2974,3.1836 0 0 1 1.649,2.7580002 l 0,-1 A 3.2974,3.1836 0 0 0 27.353,7.8335178 l -9.704,-5.4082 a 3.2974,3.1836 0 0 0 -1.57,-0.4258 z",
    style: {
      opacity: 0.2,
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3.0009,21.407518 0,1 a 3.2974,3.1836 0 0 0 1.6484,2.7559 l 9.7031,5.4102 a 3.2974,3.1836 0 0 0 3.2969,0 l 9.7031,-5.4102 a 3.2974,3.1836 0 0 0 1.648,-2.756 l 0,-1 a 3.2974,3.1836 0 0 1 -1.6484,2.7559 l -9.7031,5.4102 a 3.2974,3.1836 0 0 1 -3.2969,0 l -9.7036,-5.411 A 3.2974,3.1836 0 0 1 3,21.407518 Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#a81717",
      strokeWidth: 3,
      strokeLinecap: "square",
      strokeLinejoin: "round"
    },
    d: "m 10.5,9.4 h 11 l -11,13.1 h 11"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZotero);
export default __webpack_public_path__ + "static/media/zotero.2791e722ff3037df35176c71f28db16d.svg";
export { ForwardRef as ReactComponent };